export const GEORGIA_CONTEXT_CODE = 'GEORGIA';
export const GEORGIA_PRODUCT_CODE = 'a_georgia';

export const GEORGIA_SALES_ENABLED = true;
export const GEORGIA_DISCOUNT_ENABLED = false;
export const GEORGIA_REGISTRATION_FEE_OFF_ENABLED = false;
export const GEORGIA_DISCOUNT_COUPON_ID = '';
export const GEORGIA_PLAN_METRICS_VISIBLE = false;

export function normalizeGeorgiaContextCode(code?: string | null) {
  return (code || '').trim().toUpperCase();
}

export function isGeorgiaContextCode(code?: string | null) {
  return normalizeGeorgiaContextCode(code) === GEORGIA_CONTEXT_CODE;
}

export function isGeorgiaUserCountry(country?: string | null) {
  const normalizedCountry = normalizeGeorgiaContextCode(country);
  return normalizedCountry === 'GE' || normalizedCountry === 'GEORGIA';
}

export function isGeorgiaProduct(product?: { code?: string | null } | null) {
  const code = (product?.code || '').trim();
  const subtype = ((product as any)?.subtype || '').trim().toLowerCase();
  const names = [(product as any)?.name?.es, (product as any)?.name?.en, (product as any)?.name?.ka, (product as any)?.name]
    .filter(Boolean)
    .map((value) => String(value).trim().toLowerCase());

  return code === GEORGIA_PRODUCT_CODE || subtype.includes('georgia') || names.some((value) => value.includes('georgia'));
}
